import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { CreatePromocodeComponent } from './components/create-promocode/create-promocode.component';
import { ManagePromocodeComponent } from './components/manage-promocode/manage-promocode.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { PermissionsGuardService } from '../../../shared/services/permissions-guard.service';
import { AuthGuardService as AuthGuard } from '../../../shared/services/auth.guard';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY'
  }
};

const promocodeRoutes: Routes = [
  {
    path: 'create',
    component: CreatePromocodeComponent,
    canActivate: [PermissionsGuardService, AuthGuard]
  },
  { path: 'edit/:id', component: CreatePromocodeComponent },
  {
    path: 'manage',
    component: ManagePromocodeComponent,
    canActivate: [PermissionsGuardService, AuthGuard]
  },
];

@NgModule({
  declarations: [
    CreatePromocodeComponent,
    ManagePromocodeComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(promocodeRoutes),
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule
  ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})

export class PromocodeModule { }
